import Grid from "@mui/material/Grid";
import React from "react";
import ImageArea from "./imageArea/ImageArea";
import TextArea from "./textArea/TextArea";

const BottomPanel = () => (
  <Grid container>
    <ImageArea />
    <TextArea />
  </Grid>
);

export default BottomPanel;
